import axios from "axios";
import { toast } from "react-toastify";

import GlobalUrls from '../../Utilities/General/Urls'
import { getToken } from '../../Utilities/Auth/AuthPermissions';
import { errorTimeout, networkError, serverError, expiredSession } from '../../Utilities/General/StatusHandler';

const CalibrationService = {

    getCalibrations: async build => {
    console.log('getCalibrations ejecutado', build, new Date().toISOString());
    try {
        let url = `${GlobalUrls.urlCal}?calibration_build=${encodeURIComponent(build)}&limit=10&offset=0`;
        let allResults = [];
        let visitedUrls = new Set();

        while (url) {
            if (visitedUrls.has(url)) {
                throw new Error('Pagination loop detected');
            }

            visitedUrls.add(url);

            const { data } = await axios.get(url, {
                headers: { Authorization: getToken() }
            });

            if (Array.isArray(data)) {
                return data;
            }

            if (!Array.isArray(data.results)) {
                throw new Error('Invalid paginated response');
            }

            allResults = allResults.concat(data.results);
            url = data.next;
        }

        return allResults;

    } catch (err) {
        if (err.message.includes('Network Error')) return networkError();
        if (err.message.includes('500')) return serverError();
        if (err.message.includes('504')) return errorTimeout();
        if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession();

        throw err;
    }
},

    saveNewCalibration: async newCalibration => {
        try {
            const { data } = await axios.post(
                GlobalUrls.urlCal,
                newCalibration,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    updateNoiseParameters: async (id, noiseParametersUpdated) => {
        try {
            const { data } = await axios.put(
                GlobalUrls.urlCal + `${id}/`,
                noiseParametersUpdated,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    getCalProducts: async () => {
        try {
            const { data } = await axios.get(
                GlobalUrls.urlCalProduct,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    getCalSuffix: async () => {
        try {
            const { data } = await axios.get(
                GlobalUrls.urlCalSuffix,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    saveNewCalSuffix: async newCalSuffix => {
        try {
            const { data } = await axios.post(
                GlobalUrls.urlCalSuffix,
                newCalSuffix,
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    deleteCalSuffix: async id => {
        try {
            await axios.delete(
                GlobalUrls.urlCalSuffix + `${id}/`,
                { headers: { Authorization: getToken() } }
            )
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    }

}

export default CalibrationService